// made model similar to degree and experience for future refactoring
// although we don't have checkboxes for languages in form

const LEVELS = {
  0: 'beginner',
  1: 'intermediate',
  2: 'advanced',
  3: 'fluent',
  4: 'native'
};

const templateClass = 'js-education-fields-template'

define(function (require) {
  const Forms = require('app/modules/forms');
  const FIELDS = ['name', 'level'];

  const getInputName = function(name, model_name){
    if(!model_name){
      model_name = 'job_application';
    }

    return model_name + '[languages_attributes][]['+name+']';
  };

  const getInputsData = function(container){
    const result = {};

    FIELDS.forEach(function(field_name) {
      const field = container.find('#language-' + field_name);

      if(field.attr('type') !== 'checkbox'){
        result[field_name] = field.val();
      } else {
        result[field_name] = field.is(':checked');
      }
    });

    return result;
  };

  const clearFields = function(fields){
    fields.find('input, textarea').not('.checkbox-icheck').val('');
    fields.find('.checkbox-icheck').iCheck('uncheck');
    fields.find("#language-name, #language-level").val('').trigger("chosen:updated");
    if ($(".chosen-results").css("overflow") == "auto") {
      $(".chosen-results").css("overflow", "hidden");
    } else {
      $(".chosen-results").css("overflow", "auto");
    }
  };

  const addHtml = function(data, beforeElement, model_name, clean){
    if (data.name && data.level) {
      const currentLanguage = $('li.education-fields.language .name[data-name="' + data.name + '"]:first');
      let template

      if (currentLanguage.length) {
        template = currentLanguage.closest('.education-fields');
        template.find('.object-name').attr('data-name', data.level).html(data.level);
        template.find('input[name="' + getInputName('level', model_name) + '"]').attr({ value: data.level });
        template.removeClass('dn');
      } else {
        template = $(`.${templateClass}`).clone();

        template.removeClass(`dn ${templateClass}`);
        template.find('.name').attr('data-name', data.name).html(data.name + ',&nbsp;');
        template.find('.object-name').attr('data-name', data.level).html(data.level);

        if(data.id){
          template.find('.remove-language').attr('data-url', '/languages/'+data.id);
          template.find('input').remove();
        } else {
          FIELDS.forEach(function(field_name) {
            template.find('input[name=' + field_name + ']').attr({
              name: getInputName(field_name, model_name),
              value: data[field_name]
            });
          });
        }
        template.insertBefore(beforeElement);
      }

      if (!clean) {
        clearFields(beforeElement);
      }
    }
  };

  const add = function (link, model_name) {
    const container = $('.education-fields.language-new');
    const user_inputs = getInputsData(container);
    $('#language-name').removeClass('dirty');
    $('#language-level').removeClass('dirty');

    if(link){
      const section = link.parents('.section-education');

      $.ajax({
        type: 'POST',
        url: link.attr('data-url'),
        data: { language: user_inputs },
        success: function(result){
          Forms.hideErrors(section);

          if(result.errors_html){
            Forms.showErrors(section, [], '', result.errors_html);
          } else {
            const language = $.parseJSON(result.language);
            addHtml({ id: language.id, name: language.name, level: language.level }, container, model_name);
          }
        }
      });
    } else {
      addHtml(user_inputs, container, model_name);
    }
  };

  const remove = function(link){
    const url = link.attr('data-url');

    if(url){
      $.ajax({
        type: 'DELETE',
        url: url,
        success: function(result){
          if(result.status == 'ok'){
            link.parents('li.education-fields').remove();
          }
        }
      });
    } else {
      const parent = link.parents('li.education-fields');
      const destroy = parent.find('[name*=_destroy]');
      if(destroy.length) {
        parent.addClass('dn');
        destroy.val(true);
      }else{
        parent.remove();
      }
    }
  };

  return {
    add: add,
    remove: remove,
    addHtml: addHtml
  };
});
